<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6 mb-3" v-for="settings in widgetsSettings">
                <common-widget :settings="settings"></common-widget>
            </div>
            <div class="col-md-12">
                <last-errors></last-errors>
            </div>
        </div>
    </div>
</template>


<script>
    import CommonWidget from "./charts/common/commonWidget.vue";
    import JobsPerHour from './charts/commonWidgetSettings/queuesPerHour.settings';
    import TimeByClass from './charts/commonWidgetSettings/classTimeConsumption.settings';
    import TimeByQueue from './charts/commonWidgetSettings/queuesTimeConsumption.settings';
    import JobsPerQueue from './charts/commonWidgetSettings/jobsPerQueue.settings';
    import ErrorsPerQueue from './charts/commonWidgetSettings/errorsPerQueue.settings';
    import ErrorRate from './charts/commonWidgetSettings/errorRate.settings';
    import lastErrors from './tables/lastErrors.table';

    export default {
        components: { CommonWidget, lastErrors },
        data(){
            return {
                widgetsSettings: [
                    JobsPerHour, TimeByQueue, TimeByClass,
                    JobsPerQueue, ErrorsPerQueue, ErrorRate
                ]
            }
        },

        mounted () {

        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/stats/dashboard.vue